import { addDomEvent } from "../../events/add-dom-event";
import { createProjectionNode } from "./create-projection-node";
export const DocumentProjectionNode = createProjectionNode({
    attachResizeListener: (ref, notify) => addDomEvent(ref, "resize", notify),
    measureScroll: () => ({
        x: document.documentElement.scrollLeft || document.body.scrollLeft,
        y: document.documentElement.scrollTop || document.body.scrollTop,
    }),
    checkIsScrollRoot: () => true,
});
//# sourceMappingURL=DocumentProjectionNode.js.map